import styled, { CalendarDayWrapper, Scale } from '@secretescapes/falcon';

export const CalendarDayBackgroundWrapper = styled(CalendarDayWrapper)`
  & > span {
    height: 100%;
  }
`;

export const TooltipWrapper = styled('div')`
  padding: ${Scale.xs};
`;
